import React from 'react';
import FormikRadioButtons from 'src/components/formik-radio-buttons';

/**
 *
 * @requires formik.values.communityCollegeInfo
 */

const MilitaryServiceInput = () => (
  <FormikRadioButtons
    name="communityCollegeInfo.militaryService"
    options={[
      {value: 'Yes', label: 'Yes'},
      {value: 'No', label: 'No'},
    ]}
    legendText={
      <>
        <p>Will you be eligible for military education benefits when you transfer?</p>
        <span>
          If applicable, please answer based on your current or previous service in the U.S. Armed
          Forces, or as a dependent of someone who served.
        </span>
      </>
    }
  />
);

export default MilitaryServiceInput;
